export default "__VITE_ASSET__D27kv856__"